import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from "@angular/core";

@Directive({
    selector: ".prime-card", // 🔥 applies automatically to all prime-card
})
export class PrimeCardLayoutDirective implements AfterViewInit, OnDestroy {
    private resizeObserver!: ResizeObserver;

    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        const card = this.el.nativeElement;
        const footer = card.querySelector(".prime-card-footer");
        const header = card.querySelector(".prime-card-header");

        const updateLayout = () => {
            if (footer) {
                card.style.setProperty("--footer-height", `${footer.offsetHeight}px`);
            }
            if (header) {
                card.style.setProperty("--header-height", `${header.offsetHeight}px`);
            }
        };

        updateLayout();

        this.resizeObserver = new ResizeObserver(updateLayout);

        if (footer) this.resizeObserver.observe(footer);
        if (header) this.resizeObserver.observe(header);
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
}
